import MultipleOptionsValidator from "./validators/MultipleOptionsValidator";
import FormField from "./FormField";

/*
* Options must look like:
* [ [{code: "code", name: "name"}, ...]
*/

export default class MultipleOptionsField extends FormField {
    constructor(options, isOptional = false, feature = undefined, initialValue = undefined) {
        super(isOptional, initialValue, feature);
        this.updateOptions(options);
    }

    updateOptions(options) {
        // FIXME: WE MUST UNIFIY THE OPTIONS TO BE MORE SIMILAR TO THE OPTIONFIELD.
        const codeOptions = options.map((option) => option.code);
        this._validators = [new MultipleOptionsValidator(codeOptions)];
        this._options = options;
    }

    defaultValue() {
        return [];
    }

    hasThisValue(value) {
        return this.value.includes(value);
    }

    get hasValue() {
        return this.value.length > 0;
    }

    get isValid() {
        if (this._isOptional && this._value === this.defaultValue()) {
            return true;
        }
        if (!this._isOptional && (this._value === "" || this._value === undefined || this._value.length === 0)) {
            return false;
        }
        return this._validators.every((validator) => validator.isValid(this._value));
    }

}